var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.869 7.07027C18.5115 7.24326 19.0181 7.74984 19.191 8.39234C19.5123 9.56615 19.4999 12.0126 19.4999 12.0126C19.4999 12.0126 19.4999 14.4467 19.191 15.6205C19.0181 16.263 18.5115 16.7696 17.869 16.9426C16.6952 17.2515 12 17.2515 12 17.2515C12 17.2515 7.31712 17.2515 6.13096 16.9302C5.48846 16.7572 4.98188 16.2506 4.8089 15.6081C4.5 14.4467 4.5 12.0002 4.5 12.0002C4.5 12.0002 4.5 9.56615 4.8089 8.39234C4.98188 7.74984 5.50082 7.2309 6.13096 7.05792C7.30477 6.74902 12 6.74902 12 6.74902C12 6.74902 16.6952 6.74902 17.869 7.07027ZM14.4093 12.0002L10.5049 14.249V9.75148L14.4093 12.0002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d36144558544c4f5a7c98f023731b681.svg";
export { ForwardRef as ReactComponent };